import useAuth from "./useAuth";

export default function useAllowPartner() {
    const exchangeTokenPartnerId = useAuth(
        (state) => state.exchangeTokenPartnerId,
    );
    return !!exchangeTokenPartnerId;
}
